import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCropField(organization_id, crop_field_id) {
    return RequesterV1.get(
      `organization/partners/producers/manage_crop_field/${organization_id}/crop_field/${crop_field_id}`
    );
  },
  fetchCrops(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/manage_crop_field/${organization_id}/crops`
    );
  },
  createCropField(organization_id, producer_id, crop_field) {
    return RequesterV1.post(
      `organization/partners/producers/manage_crop_field/${organization_id}/create_crop_field/${producer_id}`,
      { crop_field: crop_field }
    );
  },
  updateCropField(organization_id, crop_field_id, crop_field) {
    return RequesterV1.post(
      `organization/partners/producers/manage_crop_field/${organization_id}/update_crop_field/${crop_field_id}`,
      { crop_field: crop_field }
    );
  },
  destroyCropField(organization_id, crop_field_id) {
    return RequesterV1.get(
      `organization/partners/producers/manage_crop_field/${organization_id}/destroy_crop_field/${crop_field_id}`
    );
  }
};
